import { render, staticRenderFns } from "./ManagementDashboard.vue?vue&type=template&id=39323978&"
import script from "./ManagementDashboard.vue?vue&type=script&lang=js&"
export * from "./ManagementDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports